import React from 'react';
import { Box, Typography, AppBar, Toolbar } from '@mui/material';

interface AppLayoutProps {
  children: React.ReactNode;
  onToggleMenu: () => void;
}

const AppLayout = ({ children, onToggleMenu }: AppLayoutProps) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <AppBar 
        position="static" 
        color="inherit" 
        elevation={0} 
        sx={{ borderBottom: '1px solid #f0f0f0' }}
      >
        <Toolbar sx={{ px: 6 }}>
          <Box 
            sx={{ display: 'flex', alignItems: 'center', gap: 2, cursor: 'pointer' }}
            onClick={onToggleMenu} 
          >
            <img src="/images/LOGO.png" alt="logo" style={{ height: 40 }} />
            <Typography variant="h6" sx={{ fontWeight: 700, letterSpacing: -0.5 }}>
              Here MAI MAI
            </Typography>
          </Box>
        </Toolbar>
      </AppBar>

      <Box component="main" sx={{ flexGrow: 1, p: 4 }}>
        {children}
      </Box>
    </Box>
  );
};

export default AppLayout;